<script setup>

import useScavenge from "../composables/scavenger.js";
import {onMounted} from "vue";
const { closeModal, getSession, claimClue, toggleLoader } = useScavenge()

onMounted(async() => {
	// mark clue 1 as claimed for the week
	toggleLoader(true)
	// await getSession()
	await claimClue(2)
	toggleLoader(false)
})
</script>

<template>
	<div class="scavenger-modal-body">
		<h6 class="modal-heading">Clue #02</h6>
		<p>Pure Fibre works with the infrastructure already in your area - switching to Afrihost is simple and quick. We’ve partnered with over 30 Fibre providers. SPIDER-MAN™ is hanging out with our providers on the Pure Fibre page.</p>
		<button class="scb" @click="closeModal">Continue the hunt</button>
	</div>
</template>
